import { render, staticRenderFns } from "./SettingsArea.vue?vue&type=template&id=96e7dd68&scoped=true&"
import script from "./SettingsArea.vue?vue&type=script&lang=js&"
export * from "./SettingsArea.vue?vue&type=script&lang=js&"
import style0 from "./SettingsArea.vue?vue&type=style&index=0&id=96e7dd68&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96e7dd68",
  null
  
)

export default component.exports